import { FaqSection } from "@/components/faq/FaqSection";

export default function FaqPage() {
  return <FaqSection />;
}
